import { combineReducers } from "@reduxjs/toolkit";
import details from "./details"
import main from './main'
import ciup from './ciup'
import loading from './loading'





const dashboard = combineReducers({
  details,
  main,
  ciup,
  loading
})

export default dashboard